/* src/app/components/doc-viewer-new/doc-viewer-bottom-panel/prompt-item/prompt-item.component.scss */
.prompt-item-content {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.prompt-item {
  padding: 10px 36px 10px 16px;
  height: auto;
  cursor: default;
}
.prompt-item-title {
  font-size: 13px;
  line-height: 20px;
}
.prompt-item-complete-prompt {
  font-size: 10px;
  text-overflow: ellipsis;
  line-height: 16px;
  max-height: 32px;
  overflow: hidden;
  white-space: nowrap;
}
@supports (-webkit-line-clamp: 2) {
  .prompt-item-complete-prompt {
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.delete-button {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  border: none;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .delete-button {
  color: rgb(255, 193, 7) !important;
}
/*# sourceMappingURL=prompt-item.component.css.map */
